import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const serviceAreas = [
  { name: 'Calgary', primary: true, path: '/service-areas' },
  { name: 'Airdrie', primary: false, path: '/service-areas/airdrie' },
  { name: 'Cochrane', primary: false, path: '/service-areas/cochrane' },
  { name: 'Okotoks', primary: false, path: '/service-areas/okotoks' },
  { name: 'Chestermere', primary: false, path: '/service-areas/chestermere' },
  { name: 'Strathmore', primary: false, path: '/service-areas/strathmore' },
  { name: 'High River', primary: false, path: '/service-areas/high-river' },
  { name: 'Rocky View County', primary: false, path: '/service-areas/rocky-view-county' }
];

export const ServiceArea = () => {
  return (
    <section data-testid="service-area-section" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 1, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#1E3A5F] uppercase tracking-widest text-sm font-semibold">Service Area</span>
          
          <h2 className="font-heading font-black text-3xl sm:text-4xl text-gray-900 mt-3 mb-6">
            Serving <span className="text-[#1E3A5F]">Calgary</span> and Surrounding Areas
          </h2>
          
          <p className="text-gray-600 mb-10 text-lg max-w-2xl mx-auto">
            We provide expert mechanical services throughout Calgary and Surrounding Areas, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore, High River and Rocky View County acreages.
          </p>

          {/* Service Areas Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {serviceAreas.map((area, index) => (
              <Link
                key={area.name}
                to={area.path}
                data-testid={`service-area-${index}`}
                className={`flex items-center justify-center gap-2 p-4 rounded-xl transition-colors ${
                  area.primary 
                    ? 'bg-[#1E3A5F] text-white shadow-lg' 
                    : 'bg-white border border-gray-200 hover:border-[#1E3A5F]/30 hover:shadow-md'
                }`}
              >
                <CheckCircle className={`w-5 h-5 flex-shrink-0 ${
                  area.primary ? 'text-white' : 'text-[#1E3A5F]'
                }`} />
                <span className={area.primary ? 'font-semibold' : 'text-gray-700'}>
                  {area.name}
                </span>
              </Link>
            ))}
          </div>

          <p className="text-gray-500 text-sm mt-8">
            * Additional areas may be serviced. Contact us to confirm availability.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceArea;
